import { useNavigate } from 'react-router-dom';
import { TrendingUp, Zap, DollarSign, Bell, FileText, LayoutDashboard } from 'lucide-react';

const NAV_ITEMS = [
  { id: 'prevision', label: 'Prévision de trésorerie', icon: TrendingUp, href: '/fonctionnalites/prevision-tresorerie' },
  { id: 'stress-test', label: 'Stress test', icon: Zap, href: '/fonctionnalites/stress-test-tresorerie' },
  { id: 'subventions', label: 'Suivi des subventions', icon: DollarSign, href: '/fonctionnalites/suivi-subventions' },
  { id: 'alertes', label: 'Alertes', icon: Bell, href: '/fonctionnalites/alertes-tresorerie' },
  { id: 'reporting', label: 'Reporting financier', icon: FileText, href: '/fonctionnalites/reporting-financier' },
  { id: 'dashboard', label: 'Tableau de bord', icon: LayoutDashboard, href: '/fonctionnalites/tableau-bord-temps-reel' },
];

interface FeatureStickyNavProps {
  activeId?: string;
  onSectionClick?: (id: string) => void;
}

export function FeatureStickyNav({ activeId, onSectionClick }: FeatureStickyNavProps) {
  const navigate = useNavigate();

  function handleClick(item: typeof NAV_ITEMS[0]) {
    if (onSectionClick) {
      onSectionClick(item.id);
    } else {
      navigate(item.href);
    }
  }

  return (
    <div className="sticky top-16 z-40 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center gap-1 overflow-x-auto scrollbar-none py-0.5">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            const isActive = activeId === item.id;
            return (
              <button
                key={item.id}
                onClick={() => handleClick(item)}
                className={`flex items-center gap-1.5 px-4 py-3 text-sm font-medium whitespace-nowrap transition-all border-b-2 -mb-px ${
                  isActive
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-900 hover:border-gray-300'
                }`}
              >
                <Icon size={14} />
                {item.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
